import { render, staticRenderFns } from "./DashletChart.vue?vue&type=template&id=3308f858"
import script from "./DashletChart.vue?vue&type=script&lang=js"
export * from "./DashletChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports